import { APPOINTMENT_ROUTES, INVOICE_ROUTES } from '../../../config/api-routes';
import instance from '../../../config/instance';
import { paramsToQueryString } from '../../../utility/helpers/commonFunction';

export const generateInvoiceNumberApi = async () => {
    const response = await instance.get(INVOICE_ROUTES.GENERATE_INVOICE_NUMBER);
    return response?.data?.data;
};

export const invoiceListApi = async (params) => {
    const queryParams = paramsToQueryString(params);
    const response = await instance.get(INVOICE_ROUTES.INVOICE_LIST + queryParams);
    return response?.data?.data;
};

export const getAppointmentForInvoiceApi = async (body) => {
    const response = await instance.post(APPOINTMENT_ROUTES.GET_APPOINTMENT_FOR_INVOICE, body);
    return response?.data?.data;
};

// Reuse the same endpoint with a minimal body (no vehicle dependency)
export const getAppointmentForInvoiceByCustomerApi = async (body) => {
    const response = await instance.post(APPOINTMENT_ROUTES.GET_APPOINTMENT_FOR_INVOICE, body);
    return response?.data?.data;
};

/**
 * GET — the open invoice draft for a vehicle: `{ vehicleId }`.
 * → the draft record, or null when there is none.
 */
export const findOpenInvoiceDraftApi = async (params) => {
    const response = await instance.get(INVOICE_ROUTES.FIND_OPEN_DRAFT, { params });
    const data = response?.data?.data;
    return data?.exists ? data.draft || null : null;
};
